import { render, staticRenderFns } from "./GDataTable.vue?vue&type=template&id=3c15ebc3&scoped=true&"
import script from "./GDataTable.vue?vue&type=script&lang=js&"
export * from "./GDataTable.vue?vue&type=script&lang=js&"
import style0 from "./GDataTable.vue?vue&type=style&index=0&id=3c15ebc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c15ebc3",
  null
  
)

export default component.exports